import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color } = theme;

const titleWrap: CSSObject = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 6,
  minWidth: 0,
};

const title: CSSObject = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-all',
  fontSize: 15,
  fontWeight: 600,
  lineHeight: 1.4,
  color: color.text,
};

const tagOffset: CSSObject = {
  marginTop: 1,
};

const meta: CSSObject = {
  minWidth: 0,
  fontSize: 13,
  color: color.textSub,
};

export { titleWrap, title, tagOffset, meta };
